import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useMemo } from "react";
import { useOrganizationServices } from "@api/organizationService.api";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";

export const CloseTemplateServiceCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, unknown>) => {
        const { serviceId } = row.original;
        const { data: services = [] } = useOrganizationServices();

        const serviceName = useMemo(
            () => services.find((s) => s.id === serviceId)?.name ?? "-",
            [services, serviceId],
        );

        return (
            <ViewTableCell>
                <span className="text-secondary">{serviceName}</span>
            </ViewTableCell>
        );
    },
);
